const STORAGE_KEY = 'netlify.deploy.preferences';

export type NetlifyDeployPreferences = {
  apiToken: string;
  siteUrl: string;
};

const DEFAULTS: NetlifyDeployPreferences = {
  apiToken: '',
  siteUrl: '',
};

export function loadNetlifyDeployPreferences(): NetlifyDeployPreferences {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULTS };
    const parsed = JSON.parse(raw) as Partial<NetlifyDeployPreferences>;
    return {
      apiToken: typeof parsed.apiToken === 'string' ? parsed.apiToken : '',
      siteUrl: typeof parsed.siteUrl === 'string' ? parsed.siteUrl : '',
    };
  } catch {
    return { ...DEFAULTS };
  }
}

export function saveNetlifyDeployPreferences(prefs: NetlifyDeployPreferences): void {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      apiToken: prefs.apiToken.trim(),
      siteUrl: prefs.siteUrl.trim(),
    })
  );
}
